import { render, staticRenderFns } from "./EditPlatformForm.vue?vue&type=template&id=241f4825&lang=pug&"
import script from "./EditPlatformForm.vue?vue&type=script&lang=js&"
export * from "./EditPlatformForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports